import {
  PdfiumExports as E,
  type PdfiumApi,
  type Pointer,
} from "@pdfking/pdfium-wrap"
import { Sleep } from "@pdfking/tfunc"

import type { ReadDocumentResult } from "./ReadDocument"

const PDF_DATA_AVAIL = 1

export const EnsurePage = async (
  api: PdfiumApi,
  result: ReadDocumentResult,
  page: number,
  delay = 50
): Promise<number> => {
  const is_page_available = async () => {
    if (!result.avail) {
      return true
    }

    const status = await api.call(
      E.FPDFAvail_IsPageAvail,
      result.avail,
      page - 1,
      result.hints_ptr as Pointer
    )

    return status === PDF_DATA_AVAIL
  }

  while (true) {
    if (await is_page_available()) {
      return page
    } else {
      const { done } = await result.promise_generator!.next()

      if (done && !(await is_page_available())) {
        throw new Error(`Page ${page} not available after maximum attempts`)
      }
    }
    await Sleep(delay)
  }
}
